module.exports = __webpack_public_path__ + "img/server03.881516fd.jpg";